export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '燃爆激情的战斗冒险' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的欢乐日常' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的心动故事' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的幻想世界' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理谜题' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的无限想象' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line', description: '惊险刺激的探索旅程' },
  { slug: 'zhiyu', name: '治愈', icon: 'ri-sun-line', description: '温暖人心的治愈佳作' },
];

export interface AnimeItem {
  id: number;
  title: string;
  category: string;
  rating: number;
  episodes: number;
  status: string;
  coverImage: string;
  description: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 1, title: '进击的巨人 最终季', category: 'rexue', rating: 9.8, episodes: 16, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20poster%20dramatic%20action%20scene%20with%20giant%20titans%20and%20soldiers%20in%20dark%20atmosphere%20cinematic%20lighting%20epic%20scale%20minimalist%20poster%20style&width=600&height=800&seq=anime-cover-001&orientation=portrait',
    description: '巨人支配的世界，人类筑起高墙苟延残喘。少年艾伦·耶格尔目睹母亲被巨人吞噬，立誓要将巨人驱逐殆尽。加入调查兵团后，他逐渐揭开巨人和墙壁背后的惊天秘密。',
  },
  {
    id: 2, title: '鬼灭之刃 游郭篇', category: 'rexue', rating: 9.5, episodes: 11, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20vibrant%20red%20and%20dark%20color%20scheme%20with%20swordsman%20silhouette%20Japanese%20traditional%20pattern%20background%20dramatic%20fire%20effects%20clean%20design&width=600&height=800&seq=anime-cover-002&orientation=portrait',
    description: '灶门炭治郎与伙伴们来到繁华的游郭，调查潜伏在花街中的上弦之鬼。华丽的夜之街中，一场惊心动魄的战斗即将展开。',
  },
  {
    id: 3, title: '咒术回战 第二季', category: 'rexue', rating: 9.6, episodes: 23, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%20dark%20urban%20fantasy%20theme%20with%20mystical%20energy%20effects%20cool%20orange%20and%20black%20tones%20minimalist%20composition&width=600&height=800&seq=anime-cover-003&orientation=portrait',
    description: '五条悟与夏油杰的过去被揭开，涩谷事变爆发，咒术界面临前所未有的危机。虎杖悠仁在战斗中不断成长，直面命运的安排。',
  },
  {
    id: 4, title: '辉夜大小姐想让我告白', category: 'gaoxiao', rating: 9.3, episodes: 37, status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Kaguya%20sama%20Love%20is%20War%20romantic%20comedy%20anime%20poster%20two%20students%20facing%20each%20other%20with%20intense%20expressions%20pink%20and%20white%20soft%20tones%20elegant%20school%20setting&width=600&height=800&seq=anime-cover-004&orientation=portrait',
    description: '在名门秀知院学园，学生会会长白银御行与副会长四宫辉夜相互暗恋，却因自尊心作祟，谁都不愿先表白。天才之间的恋爱头脑战就此展开。',
  },
  {
    id: 5, title: '间谍过家家', category: 'gaoxiao', rating: 9.4, episodes: 37, status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20with%20a%20fake%20family%20of%20spy%20assassin%20and%20telepath%20girl%20retro%20Western%20style%20warm%20green%20and%20beige%20tones%20playful%20composition&width=600&height=800&seq=anime-cover-005&orientation=portrait',
    description: '为了执行任务，顶级间谍黄昏组建了一个临时家庭——女儿是会读心的超能力者，妻子是职业杀手。这个看似完美的家庭，每个人都隐藏着秘密。',
  },
  {
    id: 6, title: '堀与宫村', category: 'lianai', rating: 9.2, episodes: 13, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Horimiya%20romance%20anime%20poster%20high%20school%20couple%20with%20gentle%20smiles%20soft%20cherry%20blossom%20background%20warm%20pink%20and%20white%20color%20palette%20sweet%20atmosphere&width=600&height=800&seq=anime-cover-006&orientation=portrait',
    description: '在学校里光鲜亮丽的堀京子，放学后却是个照顾弟弟的朴素女孩。某天，班上不起眼的宫村伊澄发现了她的秘密，两人的距离就此拉近。',
  },
  {
    id: 7, title: '关于我转生变成史莱姆这档事', category: 'qihuan', rating: 9.1, episodes: 60, status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=That%20Time%20I%20Got%20Reincarnated%20as%20a%20Slime%20anime%20poster%20blue%20slime%20character%20in%20fantasy%20world%20magical%20forest%20background%20colorful%20and%20bright%20style%20adventure%20vibe&width=600&height=800&seq=anime-cover-007&orientation=portrait',
    description: '普通上班族三上悟被刺身亡后，转生到异世界成为一只史莱姆。凭借特殊能力，他收服魔兽、建立国家，开启了一段传奇冒险。',
  },
  {
    id: 8, title: '葬送的芙莉莲', category: 'qihuan', rating: 9.7, episodes: 28, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Frieren%20Beyond%20Journey%20End%20anime%20poster%20elf%20mage%20walking%20through%20beautiful%20landscape%20melancholic%20and%20peaceful%20atmosphere%20soft%20golden%20light%20minimalist%20art%20style&width=600&height=800&seq=anime-cover-008&orientation=portrait',
    description: '打败魔王的勇者一行人在和平中老去，唯有精灵魔法使芙莉莲因长寿而独自存活。她踏上一段旅程，去理解生命的意义和伙伴之间的羁绊。',
  },
  {
    id: 9, title: '夏日重现', category: 'xuanyi', rating: 9.3, episodes: 25, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20Time%20Rendering%20anime%20poster%20mysterious%20island%20setting%20with%20ocean%20view%20suspenseful%20atmosphere%20warm%20summer%20color%20tones%20shadowy%20figure%20silhouette&width=600&height=800&seq=anime-cover-009&orientation=portrait',
    description: '网代慎平回到阔别已久的故乡日都岛参加青梅竹马的葬礼，却发现岛上隐藏着诡异的秘密。时间循环、影子病，一场夏日悬疑恐怖就此展开。',
  },
  {
    id: 10, title: '石纪元', category: 'kehuan', rating: 9.0, episodes: 57, status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Dr%20Stone%20anime%20poster%20science%20and%20stone%20world%20theme%20primitive%20yet%20scientific%20aesthetic%20green%20and%20earth%20tones%20adventurous%20and%20hopeful%20vibe&width=600&height=800&seq=anime-cover-010&orientation=portrait',
    description: '全人类被神秘光芒石化，千年后天才少年千空苏醒。他决心用科学的力量重建文明，在这个石之世界中创造奇迹。',
  },
  {
    id: 11, title: '海贼王', category: 'maoxian', rating: 9.7, episodes: 1100, status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%20pirate%20ship%20sailing%20on%20grand%20ocean%20epic%20adventure%20vibe%20blue%20sky%20and%20sea%20crew%20gathered%20together%20heroic%20composition&width=600&height=800&seq=anime-cover-011&orientation=portrait',
    description: '少年蒙奇·D·路飞立志成为海贼王，率领草帽海贼团踏上伟大航路的冒险。寻找传说中的大秘宝ONE PIECE，热血与友情的航海传奇。',
  },
  {
    id: 12, title: '夏目友人帐', category: 'zhiyu', rating: 9.5, episodes: 87, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Natsume%20Book%20of%20Friends%20anime%20poster%20boy%20with%20cat%20spirit%20in%20Japanese%20countryside%20gentle%20and%20heartwarming%20atmosphere%20soft%20green%20and%20golden%20tones%20peaceful%20scene&width=600&height=800&seq=anime-cover-012&orientation=portrait',
    description: '自幼能看见妖怪的少年夏目贵志，继承了外婆的友人帐。他将名字归还给妖怪，在与各种妖怪相遇的过程中，逐渐找到属于自己的归处。',
  },
  {
    id: 13, title: '地狱乐', category: 'rexue', rating: 8.8, episodes: 13, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Hell%20Paradise%20anime%20poster%20dark%20fantasy%20island%20setting%20ninja%20warrior%20character%20exotic%20flowers%20and%20dangerous%20creatures%20mysterious%20and%20intense%20atmosphere&width=600&height=800&seq=anime-cover-013&orientation=portrait',
    description: '最强忍者画眉丸被判死刑，为获得赦免，他奉命前往传说中的极乐净土寻找不老不死仙药。然而这座岛屿上，隐藏着令人毛骨悚然的真相。',
  },
  {
    id: 14, title: '更衣人偶坠入爱河', category: 'lianai', rating: 9.0, episodes: 12, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=My%20Dress%20Up%20Darling%20anime%20poster%20cosplay%20and%20romance%20theme%20high%20school%20setting%20colorful%20fabric%20and%20costume%20details%20sweet%20and%20playful%20atmosphere&width=600&height=800&seq=anime-cover-014&orientation=portrait',
    description: '梦想成为人偶师的新菜与热爱cosplay的辣妹海梦相遇，两个看似格格不入的人因对cosplay的共同热爱而逐渐靠近，展开一段甜蜜的青春故事。',
  },
  {
    id: 15, title: '古见同学有交流障碍症', category: 'gaoxiao', rating: 8.9, episodes: 24, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Komi%20Cannot%20Communicate%20anime%20poster%20shy%20beautiful%20girl%20with%20social%20anxiety%20school%20life%20comedy%20pastel%20color%20palette%20charming%20and%20heartwarming%20style&width=600&height=800&seq=anime-cover-015&orientation=portrait',
    description: '古见硝子是一位公认的美少女，但她却有严重的交流障碍症。只野仁人成为她第一个朋友后，帮助她实现交100个朋友的梦想。',
  },
  {
    id: 16, title: '死神 千年血战篇', category: 'rexue', rating: 9.4, episodes: 40, status: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Bleach%20Thousand%20Year%20Blood%20War%20anime%20poster%20Ichigo%20with%20sword%20in%20dramatic%20pose%20dark%20and%20intense%20color%20scheme%20epic%20battle%20atmosphere%20soul%20reaper%20theme&width=600&height=800&seq=anime-cover-016&orientation=portrait',
    description: '灭却师始祖友哈巴赫率领无形帝国向尸魂界宣战。黑崎一护再次拿起斩魄刀，与伙伴们一起踏上守护尸魂界的最终战役。',
  },
];

export interface ArticleItem {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  date: string;
  author: string;
  tags: string[];
  coverImage: string;
}

export const articles: ArticleItem[] = [
  {
    id: 1,
    title: '2024年最值得期待的10部新番动画盘点',
    excerpt: '新的一年带来了众多令人兴奋的新番作品，从热血战斗到治愈日常，我们为你精选了最值得关注的十部作品。',
    content: `<p>随着2024年的到来，动漫爱好者又迎来了一批令人期待的新番作品。本季度的阵容堪称豪华，无论你是哪类动漫的粉丝，都能找到自己的心头好。</p>
    <h4>热血战斗类</h4>
    <p>《进击的巨人》完结后，热血战斗番的接力棒传到了《咒术回战》、《鬼灭之刃》等作品手中。这些作品不仅拥有精良的制作水准，更在剧情深度上不断突破。</p>
    <p>MAPPA、Ufotable等顶级动画制作公司持续发力，为观众带来视觉盛宴。精细的战斗分镜、震撼的音效设计，让每一场战斗都成为艺术品。</p>
    <h4>治愈日常类</h4>
    <p>在忙碌的生活中，治愈系动漫为观众提供了心灵的慰藉。《葬送的芙莉莲》以其独特的叙事方式和深刻的情感表达，成为年度现象级作品。</p>
    <p>这类作品往往通过细腻的情感描绘和唯美的画面，让观众在观看过程中感受到温暖与力量。</p>
    <h4>悬疑推理类</h4>
    <p>悬疑题材在动漫领域持续升温，《夏日重现》等作品凭借精巧的剧情设计和出人意料的转折，吸引了大量忠实观众。</p>`,
    category: 'rexue', categoryName: '热血', date: '2024-08-01', author: '风车动漫编辑部', tags: ['新番', '推荐', '盘点'],
    coverImage: 'https://readdy.ai/api/search-image?query=New%20anime%202024%20season%20poster%20collage%20colorful%20anime%20characters%20from%20popular%20series%20bright%20and%20exciting%20composition%20promotional%20banner%20style&width=800&height=450&seq=article-cover-001&orientation=landscape',
  },
  {
    id: 2,
    title: '从零开始的动漫入坑指南：新人必看经典作品推荐',
    excerpt: '刚接触动漫不知道该从何看起？这份精心整理的入坑指南，帮你快速找到适合自己的入门作品。',
    content: `<p>动漫世界广阔无垠，对于刚入坑的新人来说，选择第一部作品往往是最困难的。不用担心，这份指南将帮助你找到最适合自己的起点。</p>
    <h4>如果你喜欢热血冒险</h4>
    <p>《海贼王》是日本漫画史上的传奇，路飞和他的伙伴们在大海上的冒险故事感动了无数人。虽然是超长篇作品，但每一篇章都精彩纷呈。《鬼灭之刃》则以精良的制作和感人的剧情，成为近年来入坑的最佳选择之一。</p>
    <h4>如果你喜欢搞笑日常</h4>
    <p>《辉夜大小姐想让我告白》将恋爱与搞笑完美结合，天才之间的头脑战让人捧腹又心动。《间谍过家家》则以温馨搞笑的家庭日常获得全民喜爱。</p>
    <h4>如果你喜欢深度剧情</h4>
    <p>《进击的巨人》是一部颠覆性极强的作品，宏大的世界观和精妙的伏笔回收让人叹为观止。《葬送的芙莉莲》则以独特的视角探讨时间、生命与羁绊。</p>`,
    category: 'rexue', categoryName: '热血', date: '2024-07-28', author: '风车动漫编辑部', tags: ['入门', '推荐', '新手指南'],
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20beginner%20guide%20poster%20various%20popular%20anime%20characters%20gathered%20together%20friendly%20and%20welcoming%20atmosphere%20clean%20minimalist%20design%20warm%20inviting%20colors&width=800&height=450&seq=article-cover-002&orientation=landscape',
  },
  {
    id: 3,
    title: '国产动漫崛起之路：盘点近年优秀国产动画',
    excerpt: '国产动漫产业正迎来黄金发展期，优秀的国产动画作品层出不穷，让我们一起来看看这些年国产动漫的进步。',
    content: `<p>近年来，国产动漫产业经历了翻天覆地的变化。从技术水准到故事内容，国产动画正在以肉眼可见的速度追赶世界一流水平。</p>
    <h4>技术飞跃</h4>
    <p>随着3D动画技术的成熟和2D制作水平的提高，国产动画的画面质量有了质的飞跃。越来越多的作品在视觉呈现上达到了国际水准，动作场面的流畅度和画面精细度都令人印象深刻。</p>
    <h4>题材多元化</h4>
    <p>从仙侠玄幻到都市科幻，从历史传奇到现实题材，国产动画的题材越来越丰富。创作者们不再局限于传统题材，开始大胆尝试各种新颖的故事类型。</p>
    <h4>IP开发体系成熟</h4>
    <p>以网络小说为基础的动画改编成为国产动漫的一大特色。优秀的原作加上精良的制作，诞生了一批口碑与热度兼具的佳作。同时，原创动画也在不断涌现，为产业注入新鲜血液。</p>`,
    category: 'maoxian', categoryName: '冒险', date: '2024-07-20', author: '风车动漫编辑部', tags: ['国产动漫', '推荐', '产业分析'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20poster%20collage%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20anime%20cultural%20elements%20vibrant%20and%20dynamic%20composition&width=800&height=450&seq=article-cover-003&orientation=landscape',
  },
  {
    id: 4,
    title: '动漫音乐鉴赏：那些让你循环播放的动漫神曲',
    excerpt: '一部优秀的动漫离不开出色的配乐，我们整理了那些让人一听就停不下来的动漫经典歌曲。',
    content: `<p>动漫音乐是动漫作品中不可或缺的灵魂元素。一首好的主题曲或插曲，往往能让作品的感染力翻倍，甚至在多年后仍能在听众心中激起涟漪。</p>
    <h4>热血燃曲</h4>
    <p>《红莲的弓矢》让《进击的巨人》更加震撼人心，Linked Horizon独特的音乐风格与作品的史诗感完美契合。《Gurenge》则让《鬼灭之刃》的燃点更高，LiSA充满力量的嗓音成为新一代动漫音乐的标杆。</p>
    <h4>治愈神曲</h4>
    <p>《夏目友人帐》系列的配乐以温柔的旋律打动了无数观众的心。吉森信的作曲将日式美学与治愈感完美融合，每一个音符都散发着温暖。</p>
    <h4>经典永流传</h4>
    <p>从《残酷天使的行动纲领》到《Butter-Fly》，这些经典动漫歌曲跨越了时代的界限，成为一代人共同的记忆。它们不仅是动漫的配乐，更是文化的符号。</p>`,
    category: 'zhiyu', categoryName: '治愈', date: '2024-07-15', author: '风车动漫编辑部', tags: ['音乐', '推荐', '动漫歌曲'],
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20music%20concert%20poster%20vibe%20headphones%20and%20musical%20notes%20with%20anime%20style%20illustration%20vibrant%20colorful%20sound%20waves%20energetic%20atmosphere&width=800&height=450&seq=article-cover-004&orientation=landscape',
  },
  {
    id: 5,
    title: '动漫展会专题：全球各大漫展精彩回顾',
    excerpt: 'Comic Market、Anime Expo、ChinaJoy... 全球动漫展会精彩纷呈，带你回顾各大漫展的精彩瞬间。',
    content: `<p>动漫展会不仅是动漫爱好者的狂欢节，更是动漫产业的重要风向标。每年全球各地举办的动漫展会，为粉丝提供了与创作者、声优近距离接触的机会。</p>
    <h4>日本Comic Market</h4>
    <p>作为全球最大的同人志即卖会，Comic Market每年吸引超过50万人参与。这里不仅是同人创作的殿堂，更是动漫产业新趋势的发源地。许多知名漫画家都从这里起步。</p>
    <h4>美国Anime Expo</h4>
    <p>北美最大的动漫展会，汇聚了日本动漫产业的顶尖资源。众多重量级新作发布会和新番首映都选择在这里举行，是了解全球动漫趋势的绝佳窗口。</p>
    <h4>中国ChinaJoy</h4>
    <p>ChinaJoy已成为亚洲最具影响力的数字娱乐展会之一。动漫板块的规模逐年扩大，越来越多的国产动漫IP在这里展示自己，与粉丝亲密互动。</p>`,
    category: 'maoxian', categoryName: '冒险', date: '2024-07-08', author: '风车动漫编辑部', tags: ['漫展', '展会', '活动'],
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20convention%20exhibition%20hall%20poster%20crowded%20colorful%20event%20with%20cosplay%20and%20booths%20vibrant%20festival%20atmosphere%20large%20venue%20with%20anime%20decorations&width=800&height=450&seq=article-cover-005&orientation=landscape',
  },
  {
    id: 6,
    title: '治愈系动漫推荐：让心灵获得片刻安宁',
    excerpt: '在这个快节奏的时代，治愈系动漫为我们提供了一个温柔的心灵避风港。精选十部必看治愈神作。',
    content: `<p>生活节奏越来越快，压力越来越大，治愈系动漫成为了许多人的精神寄托。这些作品以其温柔细腻的叙事风格，抚慰着我们疲惫的心灵。</p>
    <h4>《夏目友人帐》</h4>
    <p>这是一部关于孤独与陪伴的故事。能看见妖怪的少年夏目贵志，在归还妖怪名字的旅途中，逐渐找到归属感。每一集都是一个独立而温暖的小故事，像一杯热茶般温暖人心。</p>
    <h4>《虫师》</h4>
    <p>以独特的东方美学构建了一个神秘而诗意的世界。"虫"是一种接近生命本源的存在，虫师银古游历各地，解决虫与人之间的种种问题。画面唯美，配乐空灵，每一帧都可以做壁纸。</p>
    <h4>《三月的狮子》</h4>
    <p>将棋少年零在孤独中遇到温暖的三姐妹一家，逐渐走出内心的阴霾。新房的导演风格与羽海野千花的原作完美结合，创造出一部关于成长、治愈与希望的作品。</p>`,
    category: 'zhiyu', categoryName: '治愈', date: '2024-07-01', author: '风车动漫编辑部', tags: ['治愈', '推荐', '心灵'],
    coverImage: 'https://readdy.ai/api/search-image?query=Healing%20iyashikei%20anime%20poster%20peaceful%20Japanese%20countryside%20with%20anime%20style%20warm%20sunlight%20gentle%20and%20calming%20atmosphere%20beautiful%20nature%20scenery&width=800&height=450&seq=article-cover-006&orientation=landscape',
  },
];

export const aboutInfo = {
  brandName: '风车动漫',
  intro: '风车动漫网是国内领先的手机动漫门户网站，自成立以来始终专注于为移动端用户提供优质的动漫内容服务。我们致力于打造最便捷、最全面的手机动漫平台，让每一位动漫爱好者都能随时随地享受动漫带来的快乐。',
  mission: '我们的使命是通过技术创新和内容整合，让动漫内容触手可及。风车动漫团队由一群热爱动漫的专业人士组成，我们持续追踪动漫行业最新动态，精心筛选和推荐优质动漫内容，为国内动漫爱好者搭建一个温暖而有活力的交流社区。',
  values: [
    { title: '专注移动', description: '全面优化移动端阅读体验，让用户通过手机即可畅享海量动漫资讯与内容。' },
    { title: '内容为王', description: '坚持高品质内容输出，每日更新最新动漫资讯、深度评测和原创专题。' },
    { title: '用户至上', description: '以用户需求为导向，持续优化产品功能和用户体验，打造一流动漫门户。' },
    { title: '热爱驱动', description: '我们不仅是动漫行业的从业者，更是动漫文化的热爱者和传播者。' },
  ],
  milestones: [
    { year: '2018', event: '风车动漫网正式上线，专注于手机动漫资讯服务' },
    { year: '2019', event: '用户突破100万，成为国内知名手机动漫门户' },
    { year: '2020', event: '内容全面升级，新增原创评测和专题栏目' },
    { year: '2021', event: '移动端体验大幅优化，页面加载速度提升50%' },
    { year: '2022', event: '用户突破500万，日活跃用户超50万' },
    { year: '2023', event: '推出智能推荐系统，为用户提供个性化动漫推荐' },
    { year: '2024', event: '持续引领手机动漫资讯行业，用户突破千万级别' },
  ],
  reviews: [
    { name: '动漫迷小王', content: '用了风车动漫两年多了，资讯更新快，界面在手机上看着也很舒服，每天必刷！', rating: 5 },
    { name: '二次元爱好者', content: '作为手机动漫门户来说非常优秀，分类清晰，找新番很方便，推荐功能也很靠谱。', rating: 5 },
    { name: '资深动漫粉', content: '测评文章写得很专业，不是那种随便搬运的内容，能看出来编辑是真的懂动漫的。', rating: 5 },
    { name: '大学生小陈', content: '每天上下课路上必看，是我的碎片时间神器。希望越做越好！', rating: 4 },
    { name: '漫评人阿杰', content: '风车动漫的新番盘点做得很用心，每次季度初都会关注他们的推荐榜单，推荐也都很靠谱。', rating: 5 },
    { name: '新入坑的小白', content: '刚开始看动漫就是通过风车动漫找的作品推荐，入坑指南对新人也非常友好。', rating: 5 },
  ],
  contact: {
    email: 'contact@fengchedongman.com',
    weibo: '@风车动漫',
    wechat: '风车动漫官方',
    address: '北京市朝阳区望京科技园',
  },
};

export const faqs = [
  { question: '风车动漫是什么类型的网站？', answer: '风车动漫是一个专注于手机动漫的门户网站，提供最新的动漫资讯、新番推荐、动漫评测、动漫盘点等内容。我们的网站针对移动设备进行全面优化，让用户通过手机即可便捷访问海量动漫信息。' },
  { question: '风车动漫提供动漫视频播放吗？', answer: '风车动漫是一个动漫资讯门户网站，主要提供动漫新闻、推荐、评测和盘点等内容服务。我们不直接提供动漫视频播放，但会为用户推荐优质的观看渠道和平台。' },
  { question: '如何在手机上获得更好的浏览体验？', answer: '风车动漫网全面针对移动设备进行了优化，您可以直接在手机浏览器中打开我们的网站。我们采用了响应式设计，确保在不同尺寸的屏幕上都能获得出色的阅读体验。' },
  { question: '风车动漫的内容更新频率如何？', answer: '我们的编辑团队每日更新动漫资讯和推荐文章，确保用户能够第一时间获取最新的动漫动态。新番季度开始时会推出特别专题，帮助用户快速了解当季作品。' },
  { question: '如何联系风车动漫的编辑团队？', answer: '您可以通过关于我们页面上的联系方式与我们取得联系，包括电子邮箱、官方微博和微信公众号。我们欢迎用户提供宝贵的意见和建议。' },
];